export default __webpack_public_path__ + "static/media/scf.f3b433c0.webp";